export default "__VITE_ASSET__DzRV$a0$__"